import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'unh-comma-joined-tags',
  templateUrl: './comma-joined-tags.component.html',
  styleUrls: ['./comma-joined-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommaJoinedTagsComponent {
  @Input() tags = [];
  @Input() maxDisplayableTags = 4;

  get displayableTags() {
    const tags = this.tags.map(t => t.name);
    return { tags: tags.slice(0, this.maxDisplayableTags), more: tags.length > this.maxDisplayableTags };
  }
}
